module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "form-view clearfix"
  }, [_c('section', {
    staticClass: "section section-white card_preview_area member_card",
    attrs: {
      "id": "formView"
    }
  }, [_c('div', {
    staticClass: "msg_card_section shop"
  }, [_c('div', {
    staticClass: "shop_panel",
    style: ({
      backgroundColor: _vm.form.color,
      backgroundImage: 'url(' + (_vm.wximageurl + _vm.form.background_pic_url) + ')'
    })
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo_area"
  }, [_c('span', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.wximageurl + _vm.form.logo_url
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.brand_name))]), _vm._v(" "), _c('p', {
    staticClass: "card_name",
    attrs: {
      "id": "js_title_preview"
    }
  }, [_vm._v(_vm._s(_vm.form.title))]), _vm._v(" "), _c('span', {
    staticClass: "qrcode"
  })]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('section', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "110px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "section-body",
    attrs: {
      "prop": "logo_url"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商户logo"
    }
  }, [_c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgChange
    }
  }, [(_vm.form.logo_url) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.logo_url
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户自定义会员卡背景图"
    }
  }, [_c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgBgChange
    }
  }, [(_vm.form.background_pic_url) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.background_pic_url
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgBgDialog,
      "sc-status": _vm.isGetImageBg
    },
    on: {
      "chooseImg": _vm.pickBgImg,
      "closeImgDialog": _vm.closeBgImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户名称",
      "prop": "brand_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "字数上限为12个汉字",
      "maxlength": 12
    },
    model: {
      value: (_vm.form.brand_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "brand_name", $$v)
      },
      expression: "form.brand_name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.form.brand_name.length) + "/12")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员卡标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "字数上限为9个汉字",
      "maxlength": 9
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.form.title.length) + "/9")]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("卡券名，字数上限为9个汉字(建议涵盖卡券属性、服务及金额)。   ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "卡券颜色",
      "prop": "color"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.color),
      callback: function($$v) {
        _vm.$set(_vm.form, "color", $$v)
      },
      expression: "form.color"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('form')
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_area"
  }, [_c('span', {
    staticClass: "member_number"
  }, [_vm._v("0268 8888 8888")]), _vm._v(" "), _c('span', {
    staticClass: "icon_info"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-531bf746", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-531bf746"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/membercard/setting.vue
// module id = 2714
// module chunks = 0